












































































































import { Vue, Component } from 'vue-property-decorator'
import navigate from '../libs/navigate'

// register the beforeRouteLeave hook
Component.registerHooks(['beforeRouteLeave'])

@Component({
  methods: {
    navigate
  }
})
export default class Checklist extends Vue {
  questionCount = 7 // be sure that this matches the number of questions in the form above
  answers = new Array<string|undefined>(this.questionCount);
  showChecklist = true
  showConsentForm = false
  showSafeMigrationForm = false
  disableSubmitBtn = true

  allQuestionsAnswered () {
    return !this.answers.includes(undefined)
  }

  answersContainNo () {
    return this.answers.includes('no')
  }

  checkUnanswered () {
    if (this.allQuestionsAnswered()) { this.disableSubmitBtn = false }
  }

  beforeRouteLeave (to: any, from: any, next: any) {
    if (this.showChecklist || (this.showConsentForm && to.name !== 'ReferralForm')) {
      this.showDialog()
        .then(next)
        .catch(() => next(false))
    } else {
      next()
    }
  }

  showDialog () {
    return (this as any).$dialog.confirm(this.$t('checkList.confirmLeavePage'), { cancelText: this.$t('checkList.button'), okText: this.$t('checkList.buttonContinue') })
  }

  submit () {
    this.showChecklist = false
    if (this.answersContainNo()) {
      this.showConsentForm = true
    } else {
      this.showSafeMigrationForm = true
    }
  }
}
